import { FormattedMessage } from 'react-intl'
import { Button, useModalContext } from '@starbucks-web/pattern-library'
import { trackSettingsAccountDeleteClick } from '../../../state/track-event.js'
import AccountDeleteDialog, {
  ACCOUNT_DELETE_DIALOG_ID,
} from './account-delete-dialog.jsx'
import { messages } from './messages.js'

const AccountDeleteButton = () => {
  const { openModal } = useModalContext()

  return (
    <Button
      className="mt4"
      color="red"
      onClick={() => {
        trackSettingsAccountDeleteClick()
        openModal({
          component: AccountDeleteDialog,
          ariaLabelledBy: ACCOUNT_DELETE_DIALOG_ID,
        })
      }}
      visualStyle="positive"
    >
      <FormattedMessage {...messages.deleteAccount} />
    </Button>
  )
}

export default AccountDeleteButton
